const auth0 = {};

export const getAuthOptions = (options) => {
    Object.assign(auth0, options);
  }

export default auth0;
